import React, { useRef, useEffect, useState } from 'react';
import benefit1 from "../../assets/TongkatAli_1.jpg";
import goat from "../../assets/goat.webp";
import prod3 from "../../assets/prod3.jpg";

const lawsuits = [
  { title: 'Increased Strength & Energy', description: 'Boosts testosterone and stamina with Tongkat Ali and Boron.', image: benefit1, link: '/Service/Depo-Provera-Lawsuit' },
  { title: 'Enhanced Libido & Performance', description: 'Improves desire and blood flow with Horny Goat Weed.', image: goat, link: '/Service/Paraquat-Lawsuit' },
  { title: 'Stress & Hormone Balance', description: 'Supports calm energy with Wild Yam and Saw Palmetto.', image: prod3, link: '/Service/Roundup-Lawsuit' },
];

const HomeThree = () => {
  const [isDesktop, setIsDesktop] = useState(typeof window !== 'undefined' ? window.innerWidth >= 768 : true);
  const cardsRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section className="px-6 sm:px-10 md:px-20 lg:px-28 py-16 bg-gradient-to-b from-[#fffdf8] to-[#f8f9fc] w-full text-center" style={{ fontFamily: 'Segoe UI' }}>

      <div className="mb-12 flex flex-col items-center justify-center">
        <h2 className="text-3xl md:text-4xl font-bold text-black mb-3 tracking-wide text-center" style={{ fontFamily: 'Segoe UI' }}>Key Benefits</h2><br></br>
        <p className="text-gray-600 max-w-2xl text-sm md:text-base text-center">
         Energy. Endurance. Everyday Confidence - Top 3 Key Benefits of ErExcel Pro
        </p>
      </div>

      {isDesktop ? (
        <div className="flex flex-wrap justify-center gap-10">
          {lawsuits.map((item, idx) => (
            <div
              key={idx}
              className="group relative bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 w-[320px]"
            >
              {/* Image */}
              <div className="relative w-full h-[200px] overflow-hidden rounded-t-2xl">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black bg-opacity-30 flex items-end justify-center p-3 rounded-t-2xl">
                  <h3 className="text-white text-lg font-semibold">{item.title}</h3>
                </div>
              </div>

              {/* Content */}
              <div className="p-5 text-left">
                <p className="text-gray-700 text-sm mb-4 leading-relaxed">{item.description}</p>

              </div>
            </div>
          ))}
        </div>
      ) : (
        <div
          ref={cardsRef}
          className="flex gap-6 overflow-x-auto scrollbar-hide pb-4 px-2"
          style={{ WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth' }}
        >
          {lawsuits.map((item, idx) => (
            <div
              key={idx}
              className="group relative min-w-[260px] max-w-[280px] bg-white rounded-2xl shadow-md overflow-hidden flex-shrink-0"
            >
              {/* Image */}
              <div className="relative w-full h-[180px]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black bg-opacity-30 flex items-end justify-center p-3">
                  <h3 className="text-white text-lg font-semibold">{item.title}</h3>
                </div>
              </div>

              {/* Content */}
              <div className="p-4 text-left">
                <p className="text-gray-700 text-xs mb-3">{item.description}</p>

              </div>
            </div>
          ))}
        </div>
      )}
      <div className='flex flex-col items-center justify-center mt-16'>
        <button className="bg-black text-[#ffffff] font-semibold p-10 md:px-8 py-3 md:py-4 rounded-md shadow  text-base md:text-lg mt-4">
         Shop Now and Feel the Difference</button>
      </div>
    </section>
  );
};

export default HomeThree;
